import { NavLink } from "react-router"
import { Nav } from "./Nav"

export const Login = () => {

    return (
        <>
            <Nav />
            <section className="flex m-4 justify-center align-middle">
                <div>
                    <h2 className="text-l font-bold">Log in to your account</h2>
                    <div className="flex my-4 p-2 rounded-lg shadow-lg bg-slate-300">
                        <form action="" method="POST" className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2 w-80">
                                <label htmlFor="email">Email</label>
                                <input type="email" name="email" id="email" required />
                            </div>
                            <div className="flex flex-col gap-2 w-80">
                                <label htmlFor="password">Password</label>
                                <input type="password" name="password" id="password" required />
                            </div>
                            <div className="flex flex-col gap-2 w-80">
                                <input className="border-solid border-2 border-black rounded-md p-2" type="submit" value="Log in" />
                            </div>
                        </form>
                    </div>
                    <div>
                        <p>
                            Don't have an account? {" "}
                            <NavLink to="/signup">
                                <strong className="hover:underline">Sign up</strong>
                            </NavLink>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}